<!--可约日期组件-->
<template>
  <div class="stock-date-container" v-if="dates.length > 0">
    <div class="stock-content" ref="stockContent" @scroll.stop="handleScroll">
      <div
        class="stock-item"
        @click="handleClick"
        :class="{ disabled: item.disabled }"
        v-for="(item, index) in dates"
        :key="index"
      >
        <div class="stock-week">周{{ item.week }}</div>
        <div class="stock-date">
          {{ item.month }}
        </div>
        <div class="stock-footer" :style="{ color: getStockStyle(item).color }">
          {{ getStockStyle(item).str }}
        </div>
      </div>
    </div>
    <div class="stock-right" @click="handleClick">
      可约 <br />
      日期
      <span class="iconfont icon-arrow-right"></span>
    </div>
  </div>
</template>

<script>
import yDate from "../../assets/js/yDate";
import { toast } from "@ykz/ykz-util/base";
import databus, { Origins } from "@ykz/ykz-http/core";
export default {
  name: "stock_date",
  props: {
    channelLinkId: [String, Number],
    goodId: [String, Number],
    productSourceType: String,
    jointCardBookUrls: String,
  },
  data: function () {
    return {
      packageId: "",
      startDate: "",
      endDate: "",
      isLoading: false,
      dates: [],
      backupDates: [],
      debounceTimeout: null,
    };
  },
  components: {},
  created() {
    // productSourceType 这个不等2就是直销的
    if (this.productSourceType != 2) {
      // 直销不需要触底加载
      this.isLoading = false;
      // 直销预约日期
      this.viewReserveStock();
    } else {
      // 非直销预约日期
      this.getProductGroups()
        .then((res) => {
          this.packageId = res.packageId;
          this.startDate = this.dateToStr(res.haveStockStartDate, "yyyy-MM-dd");
          this.endDate = yDate.getAfterDate(this.startDate, 5);
          this.getPriceInfo(1);
        })
        .catch((error) => {
          // toast(error);
        });
    }
  },
  computed: {},
  watch: {},

  mounted() {},
  methods: {
    // 监听滚动事件
    handleScroll() {
      const container = this.$refs.stockContent;
      const scrollWidth = container.scrollWidth; // 内容宽度
      const scrollLeft = container.scrollLeft; // 已滚动的宽度
      const containerWidth = container.clientWidth; // 容器的可视区域宽度
      const threshold = 10; // 容差范围

      // console.log(scrollWidth, scrollLeft, containerWidth, "handleScroll");
      // 判断是否滚动到容器右侧
      if (
        scrollLeft + containerWidth >= scrollWidth - threshold &&
        !this.isLoading
      ) {
        this.getPriceInfo(); // 滚动到底部时加载更多数据
      }
      if (
        scrollLeft + containerWidth >= scrollWidth &&
        (this.dates.length >= 30 || this.productSourceType != 2)
      ) {
        this.triggerDebouncedToStockPage();
      }
    },

    handleClick() {
      if (this.productSourceType != 2) {
        // 直销拉起日历库存
        this.$emit("viewReserveStock");
      } else {
        window.location.href = this.jointCardBookUrls;
      }
    },

    // 防抖函数，用于跳转库存页面
    triggerDebouncedToStockPage() {
      // 清除上一个定时器
      clearTimeout(this.debounceTimeout);

      // 设置新的定时器，300ms后执行 toStockPage
      this.debounceTimeout = setTimeout(() => {
        this.handleClick();
      }, 300); // 防抖时间：300ms
    },

    //获取直销预约库存
    viewReserveStock() {
      databus({
        url: "/apiv2/newbook/viewInventory",
        type: "get",
        data: {
          goodId: this.goodId,
          apiVersion: 1, //有值表示拿新数据结构
        },
        success: (res) => {
          const { code, bcode, content } = res;
          if (code == 1000 && bcode == 100) {
            const { useDate } = content[0];
            let list = useDate.map((item) => {
              // 统一字段返回
              return {
                roomCount: item.stockNum,
                price: item.price,
                disabled: item.stockNum == 0 ? true : false,
                week: this.dateToStr(item.sellDate, "w"),
                month: this.dateToStr(item.sellDate, "MM/dd"),
              };
            });

            this.dates = list.length ? list.slice(0, 30) : [];

            // this.$nextTick(() => {
            //   this.$refs.stockContent.addEventListener("scroll", this.onScroll);
            // });
          }
        },
        error: () => {
          toast("网络异常，请刷新页面重试！");
        },
        beforeSend: () => {},
        complete: () => {},
      });
    },

    // a.有库存&需补差时，展示补差金额信息（+¥{金额}）；
    // b.有库存&无补差时，展示库存信息（余{库存}，如余10，余<5）；
    // c.无库存时，置灰对应日期（暂不展示库存或补差信息）。
    getStockStyle(item) {
      let data = null;
      if (item.roomCount && item.price > 0) {
        data = {
          str: `+¥${item.price}`,
          color: "#ff7124",
        };
      }
      if (item.roomCount && item.price <= 0) {
        const roomCount =
          item.roomCount > 50
            ? `余>50`
            : item.roomCount < 5
            ? `余<5`
            : `余${item.roomCount}`;
        data = {
          str: roomCount,
          color: "#999",
        };
      }

      if (item.disabled) {
        data = {
          str: "",
          color: "#999",
        };
      }
      return data;
    },

    // 获取预约信息
    getProductGroups() {
      return new Promise((resolve, reject) => {
        $.ajax({
          url: "https://presale.yaochufa.com/package/GetBookingProductListForJointCard",
          type: "GET",
          data: {
            productId: 0,
            linkId: this.channelLinkId,
            checkInDate: yDate.getCurDate(),
            checkOutDate: yDate.getAfterDate(yDate.getCurDate(), 30),
          },
          success: (res) => {
            const { code, content } = res;
            if (code == 1000) {
              const { packageInfos } = content.bookingProductGroups[0];
              if (packageInfos.length) {
                const { productPackageId, haveStockStartDate } =
                  packageInfos[0][0];
                const data = {
                  packageId: productPackageId,
                  haveStockStartDate,
                };

                resolve(data);
              }
            } else {
              reject("获取套餐类型失败");
            }
          },
          error: () => {
            reject("获取套餐类型失败");
          },
        });
      });
    },

    getPriceInfo(num) {
      // 防止在加载过程中重复触发
      if (this.isLoading || this.dates.length >= 30) return; // 添加检查最大条数的条件
      this.isLoading = true;
      $.ajax({
        url: "https://presale.yaochufa.com/package/GetJointCardBookProductInfo",
        type: "GET",
        data: {
          productId: 0,
          packageId: this.packageId,
          channelLinkId: this.channelLinkId,
          startDate: this.startDate,
          endDate: this.endDate,
        },
        success: (res) => {
          let { code, content } = res;
          if (code == 1000) {
            const { commonPackage } = content || {};
            const { itemSetList, priceInfo,isFreeBooking } = commonPackage[0] || {};
            if(isFreeBooking) return // 免预约
            const { itemList } =
              itemSetList && itemSetList[0] ? itemSetList[0] : {};
            // 价格
            let priceInfos = priceInfo && priceInfo.length ? priceInfo : [];

            // 库存集合
            const roomCountInfos =
              itemList && itemList.length ? itemList[0].roomCountInfos : [];

            const seriesCount =
              itemList && itemList.length ? itemList[0].seriesCount : 1;

            // 合并库存到价格集合
            priceInfos.forEach((item, index) => {
              const roomItem = roomCountInfos.find(
                (room) => room.date == item.date
              );
              if (roomItem) {
                item.roomCount = roomItem.roomCount;
              }
            });

            priceInfos.forEach((item) => {
              item.month = this.dateToStr(item.date, "MM/dd");
              item.week = this.dateToStr(item.date, "w");
              if (
                !item.roomCount ||
                item.priceId == 0 ||
                item.price == "99999.99"
              ) {
                item.disabled = true;
              } else {
                item.disabled = false;
              }
            });

            // 连住的价格集合会根据seriesCount-1多返回几天
            if (seriesCount > 1 && priceInfos.length) {
              priceInfos = priceInfos.slice(
                0,
                priceInfos.length - (seriesCount - 1)
              );
            }

            // 将新数据追加到原来的数据中
            this.dates = [...this.dates, ...priceInfos];

            // 确保不超过30条
            if (this.dates.length > 30) {
              this.dates = this.dates.slice(0, 30); // 截取前30条
            }

            // 更新日期范围
            this.startDate = yDate.getAfterDate(
              this.dateToStr(
                this.dates[this.dates.length - 1].date,
                "yyyy-MM-dd"
              ),
              1
            );

            this.endDate = yDate.getAfterDate(this.startDate, 5);

            // if (num == 1) {
            //   this.$nextTick(() => {
            //     this.$refs.stockContent.addEventListener(
            //       "scroll",
            //       this.onScroll
            //     );
            //   });
            // }

            this.isLoading = false; // 完成后设置为不加载状态
            // console.log(priceInfos, "priceInfos");
            // console.log(roomCountInfos, "roomCountInfos");
          }

          this.isLoading = false; // 完成后设置为不加载状态
        },
        error: () => {},
      });
    },

    dateToStr(date, pattern) {
      // 如果输入是字符串，则尝试将其解析为 Date 对象
      if (typeof date === "string") {
        // 替换常见的日期分隔符，支持 "2024-12-06 00:00:00" 和 "2024/12/06 00:00:00"
        date = date.replace(/-/g, "/").replace("T", " ");
        date = new Date(date); // 转换为 Date 对象
      }

      // 如果输入是时间戳（数字类型），直接创建 Date 对象
      if (typeof date === "number") {
        date = new Date(date);
      }

      // 检查是否是有效的 Date 对象
      if (!(date instanceof Date) || isNaN(date.getTime())) {
        throw new Error("Invalid date input. Please provide a valid date.");
      }

      // 默认格式为 'yyyy-MM-dd'
      pattern = pattern || "yyyy-MM-dd";

      // 日期模板映射
      let o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分钟
        "s+": date.getSeconds(), // 秒
        "w+": "日一二三四五六".charAt(date.getDay()), // 星期
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
      };

      // 处理年份模板
      if (/(y+)/.test(pattern)) {
        pattern = pattern.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      // 处理其他模板
      for (let k in o) {
        if (new RegExp(`(${k})`).test(pattern)) {
          pattern = pattern.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }

      return pattern;
    },
  },
};
</script>

<style lang="scss">
.stock-date-container {
  padding: 28px 0;
  margin-top: 18px;
  font-size: 28px;
  background-color: #fff;
  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 148px;
  width: 100%;
  .stock-content {
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap; /* 保证子元素在同一行显示 */
    overflow-x: scroll;
    width: calc(100% - 140px);
    -webkit-overflow-scrolling: touch; /* 启用惯性滚动 */

    height: 100%;
    &::-webkit-scrollbar {
      //  background-color:transparent;
      display: none;
    }
    .stock-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      padding: 0 8px;
      width: 125px;
      flex-shrink: 0;
      font-size: 23px;
      color: #999999;
      line-height: 1;
      position: relative;
      height: 100%;
      &.disabled {
        pointer-events: none;
        opacity: 0.3;
      }
      &::after {
        content: "";
        width: 1px;
        height: 80%;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        position: absolute;
        border-right: 1px dashed #e8e8e8;
      }

      .stock-date {
        font-size: 30px;
        font-weight: bold;
        color: #333;
        flex: 1;
        // margin: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .stock-footer,
      .stock-week {
        font-size: 22px;
        flex-shrink: 0;
        display: block;
        line-height: 25px;
        text-align: center;
        height: 25px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .stock-right {
    height: 100%;
    width: 140px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff7124;
    font-size: 26px;
    position: relative;
    &::after {
      position: absolute;
      content: "";
      width: 50px;
      height: 100%;
      left: -50px;
      top: 0;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
    }
    .icon-arrow-right {
      margin-left: 6px;
      &::after {
        content: "\e613";
        font-family: "iconfont" !important;
        font-size: pxToRem(20);
        color: #ff7124;
      }
    }
  }
}
</style>
